module.exports = __webpack_public_path__ + "static/img/metaverse1.2e85f42a.png";